export enum LoaderSize {
    DEFAULT = 'default',
    SMALL = 'small',
}
